import { GenIcon } from '../helpers/IconBase.es.js';

const BarsFilterOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M16 2.00001C16 2.36668 15.7 2.66668 15.3333 2.66668H0.666667C0.3 2.66668 0 2.36668 0 2.00001C0 1.63334 0.3 1.33334 0.666667 1.33334H15.3333C15.7 1.33334 16 1.63334 16 2.00001ZM10 13.3333H6C5.63333 13.3333 5.33333 13.6333 5.33333 14C5.33333 14.3667 5.63333 14.6667 6 14.6667H10C10.3667 14.6667 10.6667 14.3667 10.6667 14C10.6667 13.6333 10.3667 13.3333 10 13.3333ZM12.6667 7.33334H3.33333C2.96667 7.33334 2.66667 7.63334 2.66667 8.00001C2.66667 8.36668 2.96667 8.66668 3.33333 8.66668H12.6667C13.0333 8.66668 13.3333 8.36668 13.3333 8.00001C13.3333 7.63334 13.0333 7.33334 12.6667 7.33334Z",
          fill: "#434657"
        }
      }
    ]
  })(props);
};

export { BarsFilterOutlined };
